import { qs, qsa } from "@fluorescent/dom";

import { section } from "@/glow";
import ProductTile from "@/lib/product-tile";
import navigationDots from "@/lib/navigation-dots";

const config = {
  bp: 608,
  partial: "[data-partial]",
  slider: "[data-slider]",
  productTile: "[data-product-tile]",
  tileOrPlaceholder: "[data-product-tile], [data-placeholder-tile]",
  navDots: "[data-nav-dots]",
};

section("complementary-products", {
  dotNavigation: null,
  onLoad() {
    this.sectionId = this.container.dataset.sectionId;
    this.productId = this.container.dataset.productId;
    this.productSource = this.container.dataset.productSource;
    this.limit = this.container.dataset.limit;
    this.slider;
    this.productTiles = [];

    if (this.productSource === "app-recommendations") {
      this._loadComplementaryProducts();
    } else {
      this._initSlider();
    }
  },

  _loadComplementaryProducts() {
    const requestUrl = `${theme.routes.productRecommendations}?section_id=${this.sectionId}&limit=${this.limit}&product_id=${this.productId}&intent=complementary`;

    const request = new XMLHttpRequest();
    request.open("GET", requestUrl, true);
    request.onload = () => {
      if (request.status >= 200 && request.status < 300) {
        const container = document.createElement("div");
        container.innerHTML = request.response;

        const tileOrPlaceholder = qsa(config.tileOrPlaceholder, container);
        if (tileOrPlaceholder.length > 0) {
          this.container.innerHTML = qs(config.partial, container).innerHTML;
        }

        this._initSlider();
      }
    };
    request.send();
  },

  _initSlider() {
    const sliderContainer = qs(config.slider, this.container);
    const productTiles = qsa(config.productTile, this.container);
    const navDots = qsa(config.navDots, this.container);

    if (sliderContainer) {
      import(flu.chunks.flickity).then(({ Flickity }) => {
        this.slider = new Flickity(sliderContainer, {
          adaptiveHeight: true,
          pageDots: false,
          prevNextButtons: false,
          watchCSS: true,
          wrapAround: false,
        });

        productTiles.forEach(tile => {
          this.productTiles.push(ProductTile(tile));
        });

        if (navDots) {
          this.dotNavigation = navigationDots(this.container, this.slider);

          this.slider.on("select", () => {
            this.dotNavigation.update(this.slider.selectedIndex);
          });
        }
      });
    }
  },

  onUnload() {
    this.slider && this.slider.destroy();
    this.productTiles.forEach(tile => tile.unload());
    this.dotNavigation && this.dotNavigation.unload();
  },
});
